import { useRouteBodyState } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import type { ReferenceWordMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { Pressable, View } from "@-/com.npmjs.react-native";

export function useMorphemeInfoPanelCompositionCharactersSection({
  wordCard,
}: {
  wordCard: ReferenceWordMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor {
  const [isOpen, setIsOpen] = useRouteBodyState(
    "use-morpheme-info-panel-composition-characters-section.tsx:isOpen",
    true,
  );
  const characterList = wordCard.characters.map((character) => character.grapheme);

  return {
    bodyKey: "morpheme-info-composition-word-characters-body",
    headerKey: "morpheme-info-composition-word-characters-header",
    iconName: "LuComponent",
    isOpen,
    onToggle: () => setIsOpen((previousState) => !previousState),
    renderBody: () => (
      <View className="px-4 py-3">
        <Text className="mb-3 text-base text-muted-foreground">
          Tap a character to open its info page.
        </Text>
        <View className="flex-row flex-wrap gap-3">
          {characterList.map((character, index) => (
            <Pressable
              className="size-20 items-center justify-center rounded-xs border border-border bg-surface active:bg-accent"
              key={`${character}-${index}`}
              // onPress={() =>
              //   graphemeReferenceCompoundsPageNavigator.push.mutate({ grapheme: character })
              // }
            >
              <Text className="text-4xl text-foreground">{character}</Text>
            </Pressable>
          ))}
        </View>
      </View>
    ),
    title: "Characters",
  };
}
